import BaseError from './BaseError';

class InitializeSdkError extends BaseError {
  constructor(message) {
    super(`Error in initializing sdk: ${message}`);
  }
}

export default InitializeSdkError;
